export const DEFAULT_HTTP_ERROR_MESSAGE = 'Error Processing HTTP Request';
